import { directions } from "@/mocks/home";

export default function DirectionGrid() {
  return (
    <section id="direction" className="w-full py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <p className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">深挖方向</p>
          <h2 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            往六个方向下探，而不是在每个热搜上浅尝辄止
          </h2>
          <p className="mt-3 font-body text-sm text-foreground-600">
            每个频道都用可查证的资料说话，把「背后真相」做成持续更新的内容体系。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {directions.map((d) => (
            <a
              key={d.name}
              href="#resource"
              className="group flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-200 hover:bg-background-50"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-background-50 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${d.icon} text-xl`} />
                </span>
                <span className="hidden font-label text-[10px] font-semibold uppercase tracking-widest text-foreground-400 lg:inline">
                  {d.english}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{d.name}</h3>
              <p className="mt-1.5 flex-1 font-body text-sm leading-relaxed text-foreground-600">{d.desc}</p>
              <span className="mt-4 inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-3 py-1.5 font-label text-xs font-semibold text-background-50 transition-colors group-hover:bg-primary-600">
                {d.entry}
                <i className="ri-arrow-right-s-line text-base leading-none" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}